import Lottie from 'lottie-react';
import React from 'react';
import animationData from './../assets/animations/checkbox.json';

const CheckmarkLottie = (): JSX.Element => <Lottie autoPlay loop={false} animationData={animationData} style={{ width: 150 }} />;

export default CheckmarkLottie;
